import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { SupplierSpecialOffer } from '../../models/supplier-special-offer';

export class SupplierSpecialOffersListApi {
    constructor(protected baseUrl: string) {}

    public getSupplierSpecialOffers(
        searchParams: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<SupplierSpecialOffer>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/supplier-special-offers`, { params: searchParams }),
            response => response.data
        );
    }
}
